import { useParams } from "react-router-dom";
import { SubRoutingURLs } from "../common/RoutingURLs";
import { Box } from "@mui/material";
import ExpenseRequest from "./ExpenseRequest/ExpenseRequest";
import PrintVoucher from "./PrintVoucher/PrintVoucher";
import ImportBudgets from "./ImportBudgets/importBudgets";
import ViewRequests from "./ViewRequests/ViewRequests";
import AddOrUpdateBudget from "./AddOrUpdateBudget/AddOrUpdateBudget";
import Accounts from "./Accounts/Accounts";
import SubAccounts from "./SubAccounts/SubAccounts";

import CustomReport from "./CustomReport/CustomReport";
import ExpenseReport from "./ExpenseReport/ExpenseReport";
import ApprovedExpenses from "./ApprovedExpenses/ApprovedExpenses";
import AuthorizeTabs from "./Authorize/authorizeTabs";

import { Toaster } from "react-hot-toast";
import DataEntryVendors from "../dataEntry/vendors/vendors";

const ExpenseVoucherType = () => {
  const { expenseVoucherType } = useParams();

  let componentToRender: JSX.Element;

  switch (expenseVoucherType) {
    case SubRoutingURLs.EXPENSE_REQUEST:
      componentToRender = <ExpenseRequest />;
      break;
    case SubRoutingURLs.PRINT_VOUCHER:
      componentToRender = <PrintVoucher />;
      break;
    case SubRoutingURLs.IMPORT_BUDGETS:
      componentToRender = <ImportBudgets />;
      break;
    case SubRoutingURLs.VIEW_REQUESTS:
      componentToRender = <ViewRequests />;
      break;
    case SubRoutingURLs.UPDATE_BUDGET:
      componentToRender = <AddOrUpdateBudget />;
      break;
    case SubRoutingURLs.ACCOUNTS:
      componentToRender = <Accounts />;
      break;
    case SubRoutingURLs.ADD_SUB_ACCOUNT:
      componentToRender = <SubAccounts />;
      break;
    case SubRoutingURLs.CUSTOM_REPORT:
      componentToRender = <CustomReport />;
      break;
    case SubRoutingURLs.EXPENSE_REPORT:
      componentToRender = <ExpenseReport />;
      break;
    case SubRoutingURLs.APPROVED_EXPENSES:
      componentToRender = <ApprovedExpenses />;
      break;
    case SubRoutingURLs.AUTHORIZE:
      componentToRender = <AuthorizeTabs />;
      break;
      case SubRoutingURLs.VENDORS:
        componentToRender = <DataEntryVendors />;
        break;
    default:
      componentToRender = <Box>Page not found</Box>;
  }

  return (
    <>
      <Toaster />
      {componentToRender}
    </>
  );
};
export default ExpenseVoucherType;